import { bebop as bebopApi } from 'core/api/definitions/bebop';


export const menuQuery = queryParams => {
  return {
    queryKey: ['bebopApi', 'getMenu', queryParams],
    queryFn: ({ queryKey: [, method, params] }) => bebopApi[method](params),
  };
};
